import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule],
  template: `
<!-- FOOTER -->
<footer>
  <div class="well well-sm">
    <p class="float-end"><a href="#">Back to top</a></p>
    <p><a routerLink="/login" class="copyright-link">&copy; 2014 Cory Hake</a> &middot;
      <a href="javascript:void(0)" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#privacyModal">Privacy</a> &middot;
      <a href="javascript:void(0)" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#termsModal">Terms</a>
    </p>
  </div>
</footer>

<!-- Privacy Modal -->
<div class="modal fade" id="privacyModal" tabindex="-1" role="dialog" aria-labelledby="privacyModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="privacyModalLabel">Privacy Policy</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>We value your privacy in the simplest way possible, by collecting no information about you.</p>
        <p>We collect anonymous usage and traffic statistics, but never store your information or provide it to third parties.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Terms Modal -->
<div class="modal fade" id="termsModal" tabindex="-1" role="dialog" aria-labelledby="termsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="termsModalLabel">WEBSITE TERMS AND CONDITIONS</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p><b>Credit</b>
        <br>This document was created using a Contractology template available at http://www.freenetlaw.com.

        <br><br><b>Introduction</b>
        <br><br>These terms and conditions govern your use of this website; by using this website, you accept these terms and conditions in full.   If you disagree with these terms and conditions or any part of these terms and conditions, you must not use this website.

        <br><br><b>License to use website</b>
        <br><br>Unless otherwise stated, Quixys, LLC and/or its licensors own the intellectual property rights in the website and material on the website.  Subject to the license below, all these intellectual property rights are reserved.
        <br><br>You may view, download for caching purposes only, and print pages from the website for your own personal use, subject to the restrictions set out below and elsewhere in these terms and conditions.
        <br><br>You must not:
        </p>
        <ul>
            <li>republish material from this website (including republication on another website);</li>
            <li>sell, rent or sub-license material from the website;</li>
            <li>show any material from the website in public;</li>
            <li>reproduce, duplicate, copy or otherwise exploit material on this website for a commercial purpose;</li>
        </ul>
        <p>
        <br><b>Acceptable use</b>
        <br><br>You must not use this website in any way that causes, or may cause, damage to the website or impairment of the availability or accessibility of the website; or in any way which is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity.
        <br><br>You must not use this website to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software.
        <br><br>You must not conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction and data harvesting) on or in relation to this website without Quixys, LLC's express written consent.

        <br><br><b>No warranties</b>
        <br><br>This website is provided “as is” without any representations or warranties, express or implied.  Quixys, LLC makes no representations or warranties in relation to this website or the information and materials provided on this website.
        <br><br>Without prejudice to the generality of the foregoing paragraph, Quixys, LLC does not warrant that:
        <br>
        </p>
        <ul>
            <li>this website will be constantly available, or available at all; or</li>
            <li>the information on this website is complete, true, accurate or non-misleading.</li>
        </ul>
        <p>
        <br>Nothing on this website constitutes, or is meant to constitute, advice of any kind.

        <br><br><b>Limitations of liability</b>
        <br><br>Quixys, LLC will not be liable to you (whether under the law of contact, the law of torts or otherwise) in relation to the contents of, or use of, or otherwise in connection with, this website:
        </p>
        <ul>
            <li>for any indirect, special or consequential loss; or</li>
            <li>for any business losses, loss of revenue, income, profits or anticipated savings, loss of contracts or business relationships, loss of reputation or goodwill, or loss or corruption of information or data.</li>
        </ul>
        <p>
        <br><br>These limitations of liability apply even if Quixys, LLC has been expressly advised of the potential loss.

        <br><br><b>Exceptions</b>
        <br><br>Nothing in this website disclaimer will exclude or limit any warranty implied by law that it would be unlawful to exclude or limit; and nothing in this website disclaimer will exclude or limit Quixys, LLC's liability in respect of any:
        </p>
        <ul>
            <li>death or personal injury caused by Quixys, LLC's negligence;</li>
            <li>fraud or fraudulent misrepresentation on the part of Quixys, LLC; or</li>
            <li>matter which it would be illegal or unlawful for Quixys, LLC to exclude or limit, or to attempt or purport to exclude or limit, its liability.</li>
        </ul>
        <p>
        <br><br><b>Reasonableness</b>
        <br><br>By using this website, you agree that the exclusions and limitations of liability set out in this website disclaimer are reasonable.
        <br><br>If you do not think they are reasonable, you must not use this website.

        <br><br><b>Other parties</b>
        <br><br>You agree that the limitations of warranties and liability set out in this website disclaimer will protect Quixys, LLC's officers, employees, agents, subsidiaries, successors, assigns and sub-contractors as well as Quixys, LLC.

        <br><br><b>Unenforceable provisions</b>
        <br><br>If any provision of this website disclaimer is, or is found to be, unenforceable under applicable law, that will not affect the enforceability of the other provisions of this website disclaimer.

        <br><br><b>Indemnity</b>
        <br><br>You hereby indemnify Quixys, LLC and undertake to keep Quixys, LLC indemnified against any losses, damages, costs, liabilities and expenses (including without limitation legal expenses and any amounts paid by Quixys, LLC to a third party in settlement of a claim or dispute on the advice of Quixys, LLC's legal advisers) incurred or suffered by Quixys, LLC arising out of any breach by you of any provision of these terms and conditions[, or arising out of any claim that you have breached any provision of these terms and conditions].

        <br><br><b>Breaches of these terms and conditions</b>
        <br><br>Without prejudice to Quixys, LLC's other rights under these terms and conditions, if you breach these terms and conditions in any way, Quixys, LLC may take such action as Quixys, LLC deems appropriate to deal with the breach, including suspending your access to the website, prohibiting you from accessing the website, blocking computers using your IP address from accessing the website, contacting your internet service provider to request that they block your access to the website and/or bringing court proceedings against you.

        <br><br><b>Variation</b>
        <br><br>Quixys, LLC may revise these terms and conditions from time-to-time.  Revised terms and conditions will apply to the use of this website from the date of the publication of the revised terms and conditions on this website.  Please check this page regularly to ensure you are familiar with the current version.

        <br><br><b>Assignment</b>
        <br><br>Quixys, LLC may transfer, sub-contract or otherwise deal with Quixys, LLC's rights and/or obligations under these terms and conditions without notifying you or obtaining your consent.
        <br><br>You may not transfer, sub-contract or otherwise deal with your rights and/or obligations under these terms and conditions.

        <br><br><b>Severability</b>
        <br><br>If a provision of these terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect.  If any unlawful and/or unenforceable provision would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect.

        <br><br><b>Entire agreement</b>
        <br><br>These terms and conditions constitute the entire agreement between you and Quixys, LLC in relation to your use of this website, and supersede all previous agreements in respect of your use of this website.

        <br><br><b>Law and jurisdiction</b>
        <br><br>These terms and conditions will be governed by and construed in accordance with governing law, and any disputes relating to these terms and conditions will be subject to the exclusive jurisdiction of the courts of the United States.
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
  `,
  styles: `
    .modal-content {
      color: #5a5a5a;
    }
    .copyright-link {
      color: inherit;
      text-decoration: none;
      cursor: text;
    }
    .copyright-link:hover, .copyright-link:focus {
      color: inherit;
      text-decoration: none;
    }
  `,
})
export class Footer {

}
